import { CalendarViewTypeEnum } from 'owa-calendar-view-type';
import { updateUserConfigurationAndService } from 'owa-session-store/lib/utils/updateUserConfigurationAndService';

export const VIEW_STATE_CONFIGURATION = 'OWA.ViewStateConfiguration';

export function updateCalendarPreferredViewType(calendarViewType: CalendarViewTypeEnum) {
    updateUserConfigurationAndService(
        config => {
            // Update the local user configuration store
            config.ViewStateConfiguration.CalendarViewTypeDesktop = calendarViewType;
        },
        [
            {
                key: 'CalendarViewTypeDesktop',
                valuetype: 'Integer32',
                value: [`${calendarViewType}`],
            },
        ],
        VIEW_STATE_CONFIGURATION
    );
}
